<template>
	<div class="publish">
		<div class="banner">
			<img src="http://ylxh-service.oss-cn-hangzhou.aliyuncs.com/banner_publish.jpg" />
			<div class="text">
				<img src="../../assets/images/banner_publish_text.png" />
			</div>
		</div>
		<div class="block-wrap">
      <Breadcrumbs :routes="breadRoutes" />	
      <BlockTitle title-type="publish">
        <div class="types-wrap">
          <div class="type-item"
                :class="item.id === category ? 'active' : ''"
                v-for="(item, index) in categories"
                :key="index"
                @click="onCategoryChange(item)">{{item.name}}</div>
        </div>
      </BlockTitle>
      <div class="content-wrap">
        <div class="card-list-wrap">
          <div class="card-item hand" 
                v-for="(item, index) in listData"
                :key="index">
            <div class="card-item-img"><img :src="item.coverImg || tempCoverImg" alt=""></div>
            <div class="card-item-detail">
              <div class="card-item-detail-header">
                <h4 class="card-item-detail-header-title">
                  {{item.title}}
                </h4>
              </div>
              <div class="card-item-detail-body">
                {{item.customBriefIntroduction}}
              </div>
              <div class="card-item-detail-footer">
                <div class="user-img"><img :src="tempLogo" alt=""></div>
                <div class="user-name">{{item.author}}</div>
                <div class="user-opts">
                  <div class="opt-item">
                    <img src="../../assets/images/icon-eye.png" alt="" />
                    <span>{{item.view_cnt || 0}}</span>
                  </div>
                  <!-- <div class="opt-item">
                    <img src="../../assets/images/icon-message.png" alt="" />
                    <span>2</span>
                  </div>
                  <div class="opt-item">
                    <img src="../../assets/images/icon-love.png" alt="" />
                    <span>88</span>
                  </div> -->
                </div>
                <div class="card-more" @click="toDetail(item)">查看详情</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <Pagination :currentPage="currentPage" :total="total" @change="pageChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import router from "@/router";
import BlockTitle from "@/components/BlockTitle";
import Breadcrumbs from "@/components/Breadcrumbs";
import Pagination from '@/components/Pagination';
import { getList } from "./service/api";
import tempLogo from '@/assets/images/about-user-img.png';
import tempCoverImg from '@/assets/tempImages/p1.png';
// import tempImg from '@/assets/tempImages/qk.png';


// ../../assets/tempImages/p1.png
//  data() {
//     return {
//       tempImg,
//       activeIndex: 1
//     }
//   },

export default {
  data() {
    return {
      tempCoverImg,
      tempLogo,
    	breadRoutes: [{
    		href: '/',
    		name: '首页'
    	}, {
    		name: '编辑出版'
    	}],
      categories: [
        {
          name: "全部",
          id: '',
        },
        {
          name: "专业书籍",
          id: 1001,
        },
        {
          name: "浙江园林",
          id: 1002,
        },
        {
          name: "浙江园林绿化信息",
          id: 1003,
        }
      ],
      listData: [],
      category: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
    }
  },
  components: {
    BlockTitle,
    Breadcrumbs,
    Pagination
  },
  mounted() {
    this.getList();
  },
  methods: {
    onCategoryChange(item) {
      this.category = item.id;
			this.currentPage = 1;
      this.getList();
    },
    getList() {
      const params = {
        current: this.currentPage,
        pageSize: this.pageSize,
        categoryDicKey: this.category,
      };
      getList(params).then((res) => {
        this.total = res.totalResult;
        this.listData = (res.list || []).map((item) => {
          item._releaseDate = moment(item.releaseDate*1000 || "").format(
            "YYYY-MM-DD"
          );
          item.coverImg = item.coverImg || tempCoverImg;
          return item;
        });
      });
    },
    pageChange(page) {
      this.currentPage = page;
      this.getList();
    },
    toDetail(item) {
      router.push(`/publish/detail?aId=${item.id}`);
    },
  },
}

</script>
<style lang="less" scoped>
@import '../../assets/less/global.less';


.banner {
	width: 100%;
	min-width: @middleWidth;
	margin-bottom: 20px;
	position: relative;

	img {
		display: block;
		width: 100%;
	}

	.text {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);

		> img {
			width: 297px;
		}
	}
}

.types-wrap {
  display: flex;
  align-items: center;

  .type-item {
    width: 120px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #9D9E9E;

    &.active {
      background: #F1F3F3;
      color: #131415;
    }
  }
}

.content-wrap {
	padding-bottom: 54px;
}
.card-list-wrap {
  margin-bottom: 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  .card-item {
    width: 590px;
		height: 232px;
  	padding: 20px 20px 30px;
		background: #F1F3F3;
		border: 4px solid #06AE63;
		margin-top: 100px;
    position: relative;
    display: flex;
    align-items: center;
    border: 4px solid transparent;

    &:nth-child(odd) {
    	margin-right: 20px;
    }

    &:hover {
      border-color: #06AE63;
    }

    &-img {
      width: 150px;
      height: 210px;
      margin-right: 20px;
      transform: translateY(-70px);

      > img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    &-detail {
      height: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;

      &-header {
        display: flex;
        align-items: center;
        height: 25px;
        margin-bottom: 10px;

        &-title {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #131415;
          line-height: 25px;
        }
      }

      &-body {
        &:extend(.line4);
        height: 96px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131415;
        line-height: 24px;
      }

      &-footer {
        margin-top: auto;
        display: flex;
        height: 25px;
        align-items: center;

        .user-img {
          width: 20px;
          height: 20px;
          margin-right: 10px;

          img {
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }

        .user-name {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #9D9E9E;
          margin-right: 20px;
        }

        .user-opts {
          height: 100%;
          display: flex;
          align-items: center;

          .opt-item {
            margin-right: 10px;
            height: 100%;
            display: flex;
            align-items: center;

            img {
              width: 16px;
              margin-right: 5px;
            }

            span {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #9D9E9E;
            }
          }
        }

        .card-more {
          width: 96px;
          height: 32px;
          line-height: 32px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #131415;
          text-align: center;
          cursor: pointer;
          margin-left: auto;

          &:hover {
            color: #FFFFFF;
            background: #06AE63;
          }
        }
      }
    }
  }
}
</style>